
























import CashbackForm from '@/components/Cashback/CForm.vue';
import { tNewCashback } from '@/store/interfaces/cashback';
import cashback from '@/store/types/cashback';
import { TeipNotifications } from '@/util/teipNotifications';
import { navLink } from '@/ts/navegationLinks';
import { mapActions } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'CreateCashback',
  components: {
    CashbackForm,
  },
  data: () => ({
    navlink: [
      {
        name: 'Cashbacks',
        active: false,
        to: '/noveltiesAndPromotions/cashback/',
      },
      {
        name: 'Nuevo cashback',
        active: true,
      }
    ] as navLink[],
    cashbackSaveSuccessfully: false,
    cashback: {
      amount_cents: 0,
      amount_currency: 'USD',
      bonus: 'percentage',
      budget_cents: 0,
      budget_currency: 'USD',
      cap: 'all',
      commerce_participation_percentage: 0,
      description: '',
      end_at: '',
      kind: 'individual',
      name: '',
      network: 'all',
      participation: 'platform',
      percentage: 0,
      platform_participation_percentage: 0,
      start_at: '',
      transactions_count: 0,
      occurrences_count: 0,
      user_occurrences_count: 0,
      minimum_amount_cents: 0,
      minimum_amount_currency: '',
      maximum_amount_cents: 0,
      maximum_amount_currency: '',
      transaction_amount_cents: 0,
      transaction_amount_currency: '',
      ceiling_amount_cents: 0,
      ceiling_amount_currency: '',
      range_minimum_amount_cents: 0,
      range_minimum_amount_currency: '',
      range_maximum_amount_cents: 0,
      range_maximum_amount_currency: '',
      average_amount_cents: 0,
      average_amount_currency: '',
      user_ids: [],
      commerce_ids: [],
      branch_ids: [],
      commerce_kind_ids: [],
      cashback_type: 'regular',
      rules: [
        {
          rule: 'all',
          data: {},
          meta: [],
        }
      ],
    },
  }),
  methods: {
    ...mapActions({
      newCashback: `cashback/${cashback.actions.SAVE_CASHBACK}`,
    }),
    async saveCashback(cashback: tNewCashback): Promise<void> {
      const notification = new TeipNotifications();
      this.newCashback({ data: cashback, })
        .then(() => {
          this.cashbackSaveSuccessfully = true;
          notification.success(':)', 'Cashback creado exitosamente');
        })
        .catch(() => {
          notification.warning(':(', 'Error al crear el cashback');
          this.cashbackSaveSuccessfully = false;
        });
    },
  },
});
